import styled from "@emotion/styled";

export const Wrapper = styled.div`
  border-top: 1px solid #e4e6f2;
  margin-top: 23px;
  padding-top: 17px;
  margin-bottom: 18px;
`;

export const Container = styled.div`
  border: solid 1px #e4e6f2;
  background-color: #ffffff;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
  padding: 14px 15px 10px 26px;
  margin-top: 17px;
`;
export const Edit = styled.button`
  background: transparent;
  border: none;
  padding: inherit;
  padding-top: 6px;
  margin-right: 11px;
  cursor: pointer;
`;
export const Delete = styled.button`
  background: transparent;
  border: none;
  padding: inherit;
  padding-top: 6px;
  cursor: pointer;
`;

export const IngredientsTitle = styled.p`
  
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.16px;
  text-align: left;
  color: #232628;
  padding-bottom: 9px;
`;

export const Quantity = styled.p`
  font-family: ProximaNova;
  font-size: 12px;
  letter-spacing: -0.12px;
  text-align: left;
  color: #232628;
`;

export const Span = styled.span`
  padding-right:4px;
`
